import * as Sentry from '@sentry/nuxt';

import { version } from './package.json';
import { getEnvironment } from '@sub/utils/configs';

Sentry.init({
  dsn: 'https://8f71dc8e7af4b1f3152ea076a2727897@o915870.ingest.us.sentry.io/4507228660498432',
  release: version,
  enabled: process.env.NODE_ENV !== 'development',
  environment: getEnvironment(),
  maxValueLength: 10000,
  normalizeDepth: 5,
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});